/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationRelationLinkChildPathParams,
	OrganisationRelationLinkChildRequest,
	OrganisationRelationLinkChildResponse,
} from '../types/OrganisationRelationLinkChild'

/**
 * POST /organisations/:organisation/children
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationRelationController.php OrganisationRelationController::linkChild
 */
export async function organisationRelationLinkChild(
	organisation: OrganisationRelationLinkChildPathParams['organisation'],
	data: OrganisationRelationLinkChildRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationRelationLinkChildResponse>> {
	return axiosInstance.post(`/organisations/${organisation}/children`, data, config)
}
